import { afterRequest, beforeRequest } from "./Store/Actions/Common/ClientRequest";
import { RedirectUrl, RedirectWithComponent } from "./Constants/Utils";
import { BaseAction, ContentType } from "./Store/Actions/RootAction";
import Router from "./Resources/Router.json"

// Middleware for actions
export const actionMiddleware = (store) => (next) => async (action) => {
    let excuteAction = new BaseAction(action);
    if (excuteAction.endPoint && excuteAction.method) {
        if (excuteAction.isLoading) {
            store.dispatch(beforeRequest());
        }

        try {
            // Call api async
            const request = await fetch(excuteAction.endPoint, excuteAction.header);

            if (excuteAction.CanSetResponse(request.status)) {
                let data = {};
                if (excuteAction.contentType === ContentType.Blob) {
                    data = request.status === 200 ? await request.blob() : await request.json();
                }
                else {
                    data = await request.json();
                }
                excuteAction.SetResponse(request.status, data);

                if (excuteAction.HasRedirect()) {
                    return RedirectUrl(data.url);
                }
            }
            else {
                RedirectWithComponent(Router.Error);
                return;
            }
        }
        catch (error) {
            excuteAction.SetDataNotConnection();
            // return;
        }
        finally {
            if (excuteAction.isLoading) {
                store.dispatch(afterRequest());
            }
        }
    }

    return next(excuteAction.ToPlanObject());
}
